import React from 'react';
import { Flex } from 'antd';
import { ChargeBeePlanId } from '@prerender/billing-shared';

import { useHasAiInsightsAccess } from '~features/ai-insights';
import { useCharbeePlanId } from '../../../hooks/usePrerenderUser';
import PricingPlanCard from './PricingPlanCard';
import PricingPlanCardLegend from './PricingPlanCardLegend';
import Plan from './Plan';

type BillingPlansListProps = {
  plans?: Plan[];
  onPlanSelected: (plan: Plan) => void;
};
function BillingPlansList({ plans = [], onPlanSelected }: BillingPlansListProps) {
  const chargebeePlanId = useCharbeePlanId();
  const showAiInsights = useHasAiInsightsAccess();

  return (
    <div style={{ overflowX: 'scroll' }}>
      <Flex gap="middle">
        <PricingPlanCardLegend showAiInsights={showAiInsights} />
        {plans.map((plan) => (
          <PricingPlanCard
            key={plan.id}
            plan={plan}
            onClick={onPlanSelected}
            current={plan.id === chargebeePlanId}
            mostPopular={plan.id === ChargeBeePlanId.Pro}
            showAiInsights={showAiInsights}
          />
        ))}
      </Flex>
    </div>
  );
}

export default BillingPlansList;
